export class BscMeasurementDetailVariableEntity{
    id:number;
    measurementDetailId:number;
    variableId:number;
    variable:string;
    value:number;

    constructor(){}
}